import createReducer, { ActionCreatorHelper } from 'store/createReducer';

type IsVisible = boolean;
type IsMessageVisible = boolean;

export type Answer = string[];
export type Answers = Record<string, Answer>;

export interface AnswerOption {
    id: string;
    answerOptionText: string;
}

export enum QuizQuestionType {
    Checkbox = 'CHECKBOX',
    Radio = 'RADIO',
}

export interface Question {
    id: string;
    text: string;
    answerType: QuizQuestionType;
    answerOptions: AnswerOption[];
}

export interface Quiz {
    id: string;
    header: string;
    quizType: {
        questions: Question[];
    };
    message?: {
        id: string;
        title: string;
        description: string;
        trigger: string;
    };
}

// ----------------------- actions -------------------------------------
const SET_QUIZ_DATA = 'SET_QUIZ_DATA';
const SET_QUIZ_VISIBLE = 'SET_QUIZ_VISIBLE';
const SET_QUIZ_MESSAGE_VISIBLE = 'SET_QUIZ_MESSAGE_VISIBLE';

interface PayloadTypes {
    [SET_QUIZ_DATA]: Quiz | null;
    [SET_QUIZ_VISIBLE]: IsVisible;
    [SET_QUIZ_MESSAGE_VISIBLE]: IsMessageVisible;
}

const ActionCreator = ActionCreatorHelper<PayloadTypes>();

export const setQuizData = ActionCreator(SET_QUIZ_DATA);
export const setQuizVisible = ActionCreator(SET_QUIZ_VISIBLE);
export const setQuizMessageVisible = ActionCreator(SET_QUIZ_MESSAGE_VISIBLE);
// ----------------------- /actions -------------------------------------

// ----------------------- reducer --------------------------------------
interface QuizState {
    data: Quiz | null;
    isVisible: IsVisible;
    isMessageVisible: IsMessageVisible;
}

const QUIZ_INITIAL_STATE: QuizState = {
    data: null,
    isVisible: false,
    isMessageVisible: false,
};

export default createReducer<QuizState, PayloadTypes>(QUIZ_INITIAL_STATE, {
    [SET_QUIZ_DATA]: (state, { payload }) => ({
        ...state,
        data: payload,
    }),
    [SET_QUIZ_VISIBLE]: (state, { payload }) => ({
        ...state,
        isVisible: payload,
    }),
    [SET_QUIZ_MESSAGE_VISIBLE]: (state, { payload }) => ({
        ...state,
        isMessageVisible: payload,
    }),
});
// ----------------------- /reducer --------------------------------------
